"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var list_1 = __importDefault(require("./list"));
/**
 * Class to create a all-play-all tournament
 * matches considering home and away rounds
 */
var Tournament = /** @class */ (function () {
    function Tournament(teams) {
        if (teams.length % 2)
            throw new Error("Teams length must be even");
        this.teams = teams;
    }
    Object.defineProperty(Tournament.prototype, "matches", {
        get: function () {
            return this.tournament();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Create two rounds ensuring the home/away inversion.
     *
     * @return {Array} A complete list of rounds with matches.
     */
    Tournament.prototype.tournament = function () {
        var matches = this.calculateMatches();
        return __spreadArray(__spreadArray([], matches), matches.map(function (round) { return round.map(function (_a) {
            var home = _a[0], away = _a[1];
            return [away, home];
        }); }));
    };
    /**
     * Based on each round, distribute teams to play
     * home or away without repetition
     *
     * @returns {Array} All rounds of the first half of the tournament
     */
    Tournament.prototype.calculateMatches = function () {
        var _this = this;
        return this.rounds([__spreadArray([], this.teams)]).map(function (round, i) {
            var home = round[0], away = round[1];
            round = i % 2 ? round : __spreadArray([away, home], round.splice(2));
            return round.reduce(_this.createMatch(__spreadArray([], round)), []);
        });
    };
    /**
     * Get two teams to play a match and
     * returns new Array with Home and Away Team
     *
     * @param {Array} round - List of teams to play in this round
     */
    Tournament.prototype.createMatch = function (round) {
        return function (match) {
            return round.length === 0 ? match : __spreadArray(__spreadArray([], match), [round.splice(0, 2)]);
        };
    };
    /**
     * Based on teams, rotate them to create rounds
     *
     * @param {Array} round - List of teams to play in this round
     * @returns {Array} With Home and Away Team
     */
    Tournament.prototype.rounds = function (teams) {
        if (teams.length !== teams[0].length - 1) {
            teams.push(list_1.default.lockedRotate(teams[teams.length - 1]));
            teams = this.rounds(teams);
        }
        return teams;
    };
    return Tournament;
}());
exports.default = Tournament;
//# sourceMappingURL=tournament.js.map